<div class="h-tab-bar" [ngStyle]="{'visibility': tabContentVisiblity ? 'visible' : 'hidden', 'display': tabContentVisiblity ? 'block' : 'none' }">
  <div #activeTabBg class="active-tab-bg"></div>
  <ul class="h-tab-bar-list">
    <ng-container *ngFor="let item of _tabList">
      <li id="{{'tab_' + type + '_' + item.id}}" [ngClass]="{'active-tab': activeTab == item.id}"  clickable (click)="selectTab(item.id)" >
        <span innerHtml="{{ item.text | translate}}"></span>
      </li>
    </ng-container>
  </ul>
</div>
<ng-content #tabBarContent></ng-content>